import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import SiteRenderer from "@/components/site/SiteRenderer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicSite() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    axios.get(`${API}/public/site/${slug}`)
      .then(({ data }) => setState({ loading: false, ...data }))
      .catch(() => setState({ loading: false, error: true }));
  }, [slug]);

  if (state.loading) return <div className="min-h-screen flex items-center justify-center text-stone-400">Chargement…</div>;
  if (state.error) return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-[#F4F0EA]">
      <div className="font-serif text-3xl text-stone-800">Ce site n'est pas disponible</div>
      <p className="mt-3 text-stone-500">Le site de mariage n'a pas encore été publié, ou l'adresse est incorrecte.</p>
    </div>
  );
  return <div className="min-h-screen"><SiteRenderer themeKey={state.theme} config={state.config} wedding={state.wedding} /></div>;
}
